import {Header, Pagination} from '@/components';
import type {PaginationProps} from '@/components/common/Pagination';
import {TableSkeleton} from '@/components/Table/TableSkeleton';

import TransactionSearch from './TransactionSearch';
import BusinessTransactionTable from './TransactionTable';
import useMerchantBusinessTransactionList from './useMerchantBusinessTransactionList';

const MerchantBusinessTransactionList = () => {
  const {
    error,
    isLoading,
    isSearch,
    isPageReset,
    fetchTransactionList,
    pageInfo,
    transactionList,
    exportFilters,
    filterCount,
    currentFilters,
    filtersToApply,
    handleApplyFilters,
    clearFilters,
    selectCurrentFilters,
    selectAppliedFilters,
  } = useMerchantBusinessTransactionList();

  const renderList = () => {
    if (isLoading) {
      return <TableSkeleton />;
    }

    if (error) {
      return (
        <p className="mt-5 text-center text-red-500">
          Failed to load transactions.
        </p>
      );
    }

    if (!transactionList || !transactionList.length) {
      return (
        <div className="flex items-center gap-1 justify-center mt-5">
          <p className="text-gray-800 dark:text-white">
            No Transactions found for this Business.
          </p>
        </div>
      );
    }

    return <BusinessTransactionTable items={transactionList} />;
  };

  return (
    <main className="mt-10 mb-5 mx-4 md:mx-10">
      <Header
        dataCy="merchant-business-transactions-title"
        title={`Business Transactions`}
      />
      <TransactionSearch
        transactions={transactionList}
        exportFilters={exportFilters}
        filterCount={filterCount}
        currentFilters={currentFilters}
        filtersToApply={filtersToApply}
        clearFilters={clearFilters}
        selectCurrentFilters={selectCurrentFilters}
        selectAppliedFilters={selectAppliedFilters}
        handleApplyFilters={handleApplyFilters}
      />

      <section className="pt-5 md:pt-5">{renderList()}</section>

      {transactionList && transactionList.length ? (
        <Pagination
          onPageChange={fetchTransactionList as PaginationProps['onPageChange']}
          total={pageInfo.total}
          isSearch={isSearch}
          isPageReset={isPageReset}
        />
      ) : null}
    </main>
  );
};

export default MerchantBusinessTransactionList;
